/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* PayInvoiceRequest
*/
export class PayInvoiceRequest {
    /**
    * Id of the credit_card to pay with
    */
    'creditCardId'?: string;
    /**
    * Amount to apply to invoice
    */
    'amount'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "creditCardId",
            "baseName": "credit_card_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "amount",
            "baseName": "amount",
            "type": "number",
            "format": "float"
        }    ];

    static getAttributeTypeMap() {
        return PayInvoiceRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

